import React from 'react';
import './StepProgress.scss';

interface StepProgressProps {
    steps: string[];
    currentStep: number;
}

const StepProgress: React.FC<StepProgressProps> = ({ steps, currentStep }) => {
    return (
        <div className="step-progress">
            {steps.map((step, index) => {
                // Determinar la clase según el índice del paso
                const stepClass =
                    index < currentStep
                        ? 'active' // Pasos anteriores
                        : index === currentStep
                            ? 'current-active' // Paso actual
                            : ''; // Pasos posteriores

                return (
                    <div key={index} className={`step ${stepClass}`}>
                        <span>{step}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default StepProgress;
